import _ from 'lodash'
// import immer from 'immer'
// import { types } from 'util'

export { TDate } from './TDate'
export { default as reconfigButton, isHelpBtn } from './button'
export * from './listvalues'
export * from './formValues'
export * from './cryptoDES'
export * from './fieldListFn'

export const nullDate = Date.UTC(1900, 0, 1)

export const wait = timeout => new Promise(resolve => setTimeout(resolve, timeout))

const getEqualfun = nulls => (o1, o2) => {
	if (_.includes(nulls, (o1 !== undefined && o1 !== null) ? o1.valueOf() : o1) && _.includes(nulls, (o2 !== undefined && o2 !== null) ? o2.valueOf() : o2)) return true
}

const equalFuns = {
	date: getEqualfun([null, undefined, nullDate]),
	datetime: getEqualfun([null, undefined, nullDate]),
	string: getEqualfun([null, undefined, '']),
	number: getEqualfun([null, undefined]),
	bool: getEqualfun([null, undefined, false])
	// files: (o1, o2) => { if (!o1 || o1.length == 0) return true }
}

export const isEqualWithType = (o1, o2, type) => type === 'array'
	? _.isEqual(_.sortBy(o1), _.sortBy(o2))
	: _.isEqualWith(o1, o2, equalFuns[type] || equalFuns.string)

/**
 * 
 * @param {*} dispatch 
 * @param {*} event 
 */
export const doOneDispatch = (dispatch, event) => doDispatchs(dispatch, [event])

/**
 * 
 * @param {*} dispatch 
 * @param {*} events 
 */
export const doDispatchs = (dispatch, events) => new Promise((resolve, reject) => {
	const promises = []

	events.forEach((event) => {
		if (!Array.isArray(event)) {
			event = [event.fn, event.data, event.onSuccess]
		}
		const [fn, data, onSuccess] = event
		promises.push(new Promise((resolve, reject) => {
			Tyan.dispatch(fn({
				...data,
				onEnd: ({ errorMessage, ...rest }) => errorMessage && reject(errorMessage) || resolve(onSuccess && onSuccess(rest) || rest)
			}))
		}))
	})

	Promise.all(promises)
		.then(results => resolve(results.reduce((a, o) => { return { ...a, ...o } })))
		.catch(errorMessage => reject(errorMessage))
})

// 更换字符串中的换行为<br>用于呈现html
export const newLineToBR = value => value && value.replace(/(\r\n|\n\r|\n|\r)/g, '<br>') || value

export const escapeRegExp = string => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

// 铺平对象，如{a:{b:c}, d:e} => {a.b:c, d:e}
// 应用于 menuComponents 和 reportCdtsFns
export const flatObject = (comps, prevSum = {}, prevKey = '', splitter = '.') => {
	return Object.entries(comps).reduce((sum, [key, value]) => {
		typeof value === 'object'
			? flatObject(value, sum, `${prevKey}${key}${splitter}`, splitter)
			: (sum[`${prevKey}${key}`] = value)
		return sum
	}, prevSum)
}


// 计算文本呈现宽度
export const getTextWidth = (text, font = '13px Roboto, sans-serif') => {
	// re-use canvas object for better performance
	const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
	const context = canvas.getContext("2d");
	context.font = font;
	const metrics = context.measureText(text);
	return metrics.width;
}

export const genObjectText = (obj, space = 2, level = 0) => {
	const objectToText = (o, ol) => {

	}

	const arrayToText = (a, al) => {

	}

	return Array.isArray(obj)
		? arrayToText(obj, level)
		: typeof obj == 'object'
			? objectToText(obj, level)
			: JSON.stringify(obj)
}